// Helpers for translating between Quill's serialized HTML (which always wraps
// each line in a <p>...</p> block) and the backend's storage format (which
// omits the outermost <p> wrapper for single-paragraph content).

// Removes the outermost <p>...</p> only when the HTML is a single top-level
// paragraph. Multi-paragraph content (e.g. <p>a</p><p>b</p>) is returned
// unchanged because there is no single outer wrapper to strip.
export const stripOuterP = html => {
  if (!html) return html;
  const match = html.match(/^<p>([\s\S]*)<\/p>$/);
  if (!match) return html;
  const inner = match[1];
  if (/<\/?p\b/i.test(inner)) return html;
  return inner;
};

// Wraps content in <p>...</p> unless it already begins with a <p> tag.
// Idempotent so legacy backend values that still carry the wrapper round-trip
// through Quill cleanly without becoming <p><p>...</p></p>.
export const wrapWithOuterP = html => {
  if (!html) return html;
  if (/^<p[\s>]/i.test(html)) return html;
  return `<p>${html}</p>`;
};
